import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import {
    Header,
    ContentBody,
    HeaderContainer,
    DetailBody,
} from 'src/pages/orders/components/reportsAndInvoice/sendUsageReport/SendUsageReport.styled';
import {
    CloseIconContainer,
    CloseIcon,
} from 'src/pages/orders/components/orderDetails/orderDetailHeader/OrderDetailHeader.styled';
import Close from 'src/assets/images/ModalClose.svg';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import PdfLoading from 'src/pages/orders/components/reportsAndInvoice/viewReport/PdfLoading';
import {
    isIpad,
    isMobileView,
    downloadFile,
    updateContainerPosition,
} from 'src/utils/util';
import { PdfMainContainer } from './AddPo.styled';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import {
    BackButtonIcon,
    BackButtonContainer,
    BackText,
} from 'src/pages/orders/components/searchOrdersPanel/searchOrdersResult/SearchOrdersResult.styled.jsx';
import BackIcon from 'src/assets/images/BaselineKeyboardArrowLeft24.svg';
import { resetPoImagePreview } from 'src/pages/reportUsage/redux/action/actionCreators';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const PoImagePreview = (props) => {
    // const { viewReportBackNavigate } = useSelector(
    //     (state) => state.reportUsageRootReducer
    // );
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { poImagePreviewDetails, poImagePreviewLoader } = useSelector(
        (state) => state.reportUsageRootReducer
    );

    useEffectWithErrorLogging(() => {
        if (
            !poImagePreviewLoader &&
            poImagePreviewDetails &&
            !(isImageFile() || poImagePreviewDetails.type === 'pdf')
        ) {
            downloadFile(getUrl(), poImagePreviewDetails.name);
        }
    }, [poImagePreviewLoader, poImagePreviewDetails]);
    const [numPages, setNumPages] = useState(null);
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const getUrl = () => {
        let url = '';
        if (poImagePreviewDetails.type === 'doc') {
            url = `data:application/msword;base64,${poImagePreviewDetails.base64}`;
        } else if (poImagePreviewDetails.type === 'pdf') {
            url = `data:application/${poImagePreviewDetails.type};base64,${poImagePreviewDetails.base64}`;
        } else {
            url = `data:image/${poImagePreviewDetails.type};base64,${poImagePreviewDetails.base64}`;
        }
        return url;
    };

    const isImageFile = () => {
        const { type: typeFromImageDetails } = poImagePreviewDetails;
        const type = typeFromImageDetails?.toLowerCase();
        return type === 'png' || type === 'jpg' || type === 'jpeg';
    };

    useEffectWithErrorLogging(() => {
        if (isMobileView()) {
            if (poImagePreviewLoader)
                updateContainerPosition('#UsageContainer', 'unset');
            else {
                updateContainerPosition('#UsageContainer', 'fixed');
            }
        }
    }, [poImagePreviewLoader]);

    return (
        <>
            {poImagePreviewLoader ? (
                <>
                    <Backdrop
                        showCloseButton={false}
                        showBackdrop={true}
                        isModal
                        loaderBackground
                    >
                        <Spinner id="reportUsage-poImagePreview-backdrop-loadingSpinner" animation="border" variant="primary" small />
                    </Backdrop>
                </>
            ) : (
                <>
                    {isImageFile() || poImagePreviewDetails.type === 'pdf' ? (
                        <ModalDialog
                            id="reportUsage-reportPayment-poImagePreview-modal"
                            modalHeight={'calc(100vh - 150px)'}
                            modalWidth={'70%'}
                            left={'0%'}
                            right={'0%'}
                            top={'7%'}
                            bottom={'5%'}
                            padding={'0px'}
                            height={'100%'}
                            marginTop={'6.75rem'}
                            zIndex={'30000'}
                            width={'50%'}
                            onClick={() => {}}
                            handleClose={(e) => {
                                props.closePoImagePreview(e);
                                dispatch(resetPoImagePreview());
                            }}
                        >
                            <ContentBody contentHeight={'calc(100% - 16px)'}>
                                <HeaderContainer
                                    alignItems={
                                        props.descrepencyExists && 'flex-start'
                                    }
                                >
                                    <Header
                                        fontSize="18px"
                                        wordBreak={
                                            props.descrepencyExists &&
                                            'break-word'
                                        }
                                    >
                                        {props.descrepencyExists
                                            ? poImagePreviewDetails?.name
                                            : t('ConsignmentAdd.shipping.addPoNonTissue.PoImagePreview.poImage')}
                                    </Header>

                                    {/* CloseIcon handled by ModalDialog handleClose */}
                                </HeaderContainer>
                                {props.descrepencyExists && (
                                    <BackButtonContainer
                                        id="reportUsage-reportPayment-poImagePreview-backButton"
                                        onClick={props.onCloseDescrepencyFile}
                                    >
                                        <BackButtonIcon src={BackIcon} />
                                        <BackText>{t('consignmentBilling.payment.reportPayment.BacktoReports')}</BackText>
                                    </BackButtonContainer>
                                )}

                                <DetailBody
                                    detailBodyPadding={'0px'}
                                    overflowX={'hidden'}
                                    pdfContainerHeight={
                                        poImagePreviewLoader ? '100%' : 'unset'
                                    }
                                    scrollBarWidth={'8px'}
                                    scrollBarBackgroundColor={'#888'}
                                    scrollBarBorderRadius={'10px'}
                                    mediumDeviceScrollBarDisplay={'block'}
                                >
                                    {poImagePreviewDetails ? (
                                        !poImagePreviewLoader &&
                                        poImagePreviewDetails.base64 ? (
                                            <PdfMainContainer
                                            // pdfContainerHeight={'100%'}
                                            >
                                                {/* <iframe src={getUrl()}></iframe> */}
                                                {isImageFile() ? (
                                                    <img
                                                        height={'100%'}
                                                        width={'100%'}
                                                        src={getUrl()}
                                                    />
                                                ) : (
                                                    <Document
                                                        file={getUrl()}
                                                        onLoadSuccess={
                                                            onDocumentLoadSuccess
                                                        }
                                                        width="100%"
                                                        renderMode={'canvas'}
                                                        loading={<PdfLoading />}
                                                    >
                                                        {[
                                                            ...Array(
                                                                numPages
                                                            ).keys(),
                                                        ].map(
                                                            (
                                                                element,
                                                                index
                                                            ) => (
                                                                <Page
                                                                    index={
                                                                        element +
                                                                        1
                                                                    }
                                                                    pageNumber={
                                                                        element +
                                                                        1
                                                                    }
                                                                    scale={
                                                                        isIpad() ||
                                                                        isMobileView()
                                                                            ? 1.0
                                                                            : 1.5
                                                                    }
                                                                    key={index}
                                                                />
                                                            )
                                                        )}
                                                    </Document>
                                                )}

                                                {/* <React.Fragment>
                                        {poImagePreviewDetails.type ===
                                        'pdf' ? (
                                            <>
                                                <Document
                                                    file={`data:application/${poImagePreviewDetails.type};base64,${poImagePreviewDetails.base64}`}
                                                    onLoadSuccess={
                                                        onDocumentLoadSuccess
                                                    }
                                                    width="100%"
                                                    renderMode={'canvas'}
                                                    loading={<PdfLoading />}
                                                >
                                                    {getPages()}
                                                </Document>
                                            </>
                                        ) : (
                                            <img
                                                src={`data:image/${poImagePreviewDetails.type};base64,${poImagePreviewDetails.base64}`}
                                            />
                                        )}

                                        <StyledHorizontalRow />
                                    </React.Fragment> */}
                                            </PdfMainContainer>
                                        ) : (
                                            <PdfLoading />
                                        )
                                    ) : null}
                                </DetailBody>
                            </ContentBody>
                        </ModalDialog>
                    ) : null}
                </>
            )}
        </>
    );
};

export default PoImagePreview;
